<template>
  <el-select
    :placeholder="placeholder"
    v-model.trim="selectedValue"
    @change="handleChange"
    remote
    :remote-method="filterMethod"
    filterable
    clearable
    :multiple="multiple"
  >
    <el-option v-for="(item, idx) in options" :key="idx" :label="item[labelKey]" :value="item[valueKey]" :disabled="optionDisabled && item.status == 1"></el-option>
  </el-select>
</template>
<script setup>
import {
  ref, watch, getCurrentInstance, computed, onMounted,
} from 'vue';
// props
const props = defineProps({
  placeholder: {
    type: String,
    default: null,
  },
  list: {
    type: Array,
    default: () => [],
  },
  multiple: {
    type: Boolean,
    default: false,
  },
  labelKey: {
    type: String,
    default: 'label',
  },
  valueKey: {
    type: String,
    default: 'value',
  },
  optionDisabled: {
    type: Boolean,
    default: false,
  },
});
// ref
const selectedValue = ref(props.modelValue);
const options = ref([]);
// emit
const emit = defineEmits(['update:modelValue']);

// watch
// 监听传入的 modelValue 的变化，并更新 selectedValue
watch(() => props.modelValue, (newVal) => {
  selectedValue.value = newVal;
});
watch(() => props.list, (newVal, oldVal) => {
  options.value = newVal;
}, { immediate: true });
// methods
// 当选中项改变时，向父组件发送事件
function handleChange(value) {
  emit('update:modelValue', value);
}
function filterMethod(value) {
  if (!value) return;
  options.value = props.list.filter((item) => String(item[props.labelKey]).toLowerCase().includes(value.toLowerCase()));
}
</script>
